module.exports = __webpack_public_path__ + "img/22.4db2a498.png";